import api from "./api";

export const getBookings = async (courtId, date, customerId) => {
  return api
    .get({
      endpoint: `/all/hour/list/${courtId}/${date}?customerId=${customerId}`,
      port: process.env.REACT_APP_PORT_OPENHOUR,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
